import React from "react";
import classNames from "classnames";
import { Avatar } from '../Avatar/Avatar';
import { useIsMobile } from '../../utils';

import "./MessageWithAvatar.scss";

export interface IMessageWithAvatarProps {
  avatarName?: string;
  avatarPlacement?: "left" | "right" | "bottom";
  avatarUrl?: string;
  children?: React.ReactNode;
}

/**
 * A message with an avatar.
 *
 * @status stable
 */
export const MessageWithAvatar: React.FC<IMessageWithAvatarProps> = (props) => {

  const { avatarName, avatarPlacement, avatarUrl, children } = props;

  const placement = useIsMobile() ? "bottom" : avatarPlacement;

  return (
    <div className={classNames("message", placement && `message--avatar-placement-${placement}`)}>

      <figure className="message__avatar-wrapper">
        <Avatar className="message__avatar" source={avatarUrl}/>
        <figcaption className="message__avatar-name">{avatarName}</figcaption>
      </figure>

      <div className={classNames("message__content", placement && `message__content--avatar-placement-${placement}`)}>
        {children}
      </div>

    </div>
  );
}

MessageWithAvatar.defaultProps = {
  avatarPlacement: "left",
};
